<template>
<div class="chapter">
<div class="inner_page">
<p class="ded-f"><a id="page_7"><em>To Julie Klassen and Michelle Griep. You are both shining examples of what friendship should be.</em></a></p><a id="page_7">
<p class="ded1"><em>To all the members of the Inspirational Regency Readers group on Facebook. You are so appreciated!</em></p>
</a><p class="ded1"><a id="page_7"><em>And to Peter, always, with my love.</em></a><a id="page_8"></a></p><a id="page_8">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 006_Dedication.vue?4e26eef0